import { BarChart } from '@mui/x-charts/BarChart';
import { Box, Typography, Stack } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';

const Graph = ({ Data, theme }) => {
  if (!Data) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
          px: 2,
          textAlign: 'center',
          bgcolor: '#fafafa',
          borderRadius: '12px',
          border: '1px solid #eee',
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: '#fff',
            border: '1px solid #eee',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <BarChartIcon sx={{ color: 'text.secondary' }} />
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          No email statistics available
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Weekly Postmark send, bounce, open, and spam counts will appear here once stats are available.
        </Typography>
      </Box>
    );
  }

  const weekLabel = `${new Date(Data.weekStart).toLocaleDateString('en-GB', {
    month: 'short',
    day: 'numeric',
  })} – ${new Date(Data.weekEnd).toLocaleDateString('en-GB', {
    month: 'short',
    day: 'numeric',
  })}`;

  const labels = ['Sent', 'Bounced', 'Opens', 'Spam'];
  const values = [
    Data.sent ?? 0,
    Data.bounced ?? 0,
    Data.opens ?? 0,
    Data.spam_complaints ?? 0,
  ];
  const colors = [
    theme.palette.primary.main,
    '#424242',
    '#2e7d32',
    '#c62828',
  ];

  return (
    <Box sx={{ width: '100%', p: { xs: 1, md: 2 } }}>
      <Stack spacing={0.5} sx={{ mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Weekly email activity
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {weekLabel}
        </Typography>
      </Stack>

      <BarChart
        xAxis={[
          {
            scaleType: 'band',
            data: labels,
            colorMap: {
              type: 'ordinal',
              values: labels,
              colors,
            },
          },
        ]}
        series={[
          {
            data: values,
            label: 'Count',
          },
        ]}
        height={300}
        borderRadius={8}
        grid={{ horizontal: true }}
      />
    </Box>
  );
};

export default Graph;
